module.exports = __webpack_public_path__ + "static/media/deleteIcon.3644baae.svg";